import { useFeatureFlags } from 'features/project/hooks/use-feature-flags'

const WEB_SEARCH_FLAG = 'web_search'
const CONNECTORS_ASK_YOGI_FLAG = 'connectors_ask_yogi'
const SAVE_PROMPTS_FLAG = 'save_ask_yogi_prompts'
// Gates the live run-steps UI (PROD-5081) while its design is still being
// finalized, so the streaming path ships to prod dark. Retire — flag and both
// gates — once the streaming design is finalized and rolled out to everyone.
const STREAMING_FLAG = 'ask_yogi_streaming'
// Gates the server-side stop control (PROD-5082) while it rolls out. Retire —
// flag and gate — once stopping is on for everyone.
const STOP_GENERATION_FLAG = 'ask_yogi_stop_generation'
// Gates the Ask Yogi side panel (PROD-5792) and everything scoped to it,
// including the chart handoff + collapsed-chip flow (PROD-5584/5795) and the
// ResourceCard annotation redesign. Same flag string
// `use-ask-yogi-anywhere.ts` already hardcodes for the sidebar itself — do
// not introduce a second literal for it.
const DASHBOARDS_2_1_FLAG = 'dashboards_2_1'
export {
  ASKYOGI_EVERYWHERE_FLAG,
  useIsAskYogiEverywhere,
} from 'features/ask-yogi/ask-yogi-everywhere'

const useAskYogiFeatureFlag = (flagName: string): boolean => {
  const { data: featureFlags } = useFeatureFlags()
  return (
    (featureFlags as Record<string, boolean | undefined> | undefined)?.[
      flagName
    ] === true
  )
}

export const useIsAskYogiWebSearchEnabled = (): boolean =>
  useAskYogiFeatureFlag(WEB_SEARCH_FLAG)

export const useIsAskYogiConnectorsEnabled = (): boolean =>
  useAskYogiFeatureFlag(CONNECTORS_ASK_YOGI_FLAG)

export const useIsAskYogiSavePromptsEnabled = (): boolean =>
  useAskYogiFeatureFlag(SAVE_PROMPTS_FLAG)

export const useIsAskYogiStreamingEnabled = (): boolean =>
  useAskYogiFeatureFlag(STREAMING_FLAG)

export const useIsAskYogiStopGenerationEnabled = (): boolean =>
  useAskYogiFeatureFlag(STOP_GENERATION_FLAG)

export const useIsDashboards21Enabled = (): boolean =>
  useAskYogiFeatureFlag(DASHBOARDS_2_1_FLAG)
